<template>
  <Teleport to="#teleported">
    <Transition :name="transition">
      <div
        v-if="open"
        ref="dialogContainer"
        class="absolute inset-0 z-30 flex w-screen flex-col overflow-y-auto overflow-x-hidden bg-white"
        :class="{
          'bg-white/50 backdrop-blur-md': backgroundBlur,
          'scrollbar-hidden overflow-y-hidden': scrollDisabled,
        }"
      >
        <div
          class="z-50 mb-5 flex items-center justify-between bg-white px-4 pb-2 pt-4 md:mx-0 md:w-screen md:px-4 portrait:md:top-0"
          :class="{
            'sticky top-0': sticky,
            'portrait:md:absolute': !sticky,
            'border-b': showHeaderBorderBottom,
          }"
        >
          <!-- Top Icons -->
          <LexmeaLogo
            :class="{
              'h-[1.57rem] w-[7.5rem]': logoSize === 'base',
              'h-[1.57rem] w-[4.5rem]': logoSize === 'sm',
            }"
            :isBlue="true"
          />
          <button
            class="h-7 w-7 rounded-full bg-white/40"
            :title="$t('ui.close')"
            @click="$emit('close')"
          >
            <i-material-symbols-close-rounded class="size-full" />
          </button>
        </div>
        <div class="flex-1">
          <slot></slot>
        </div>
        <div class="sticky bottom-0 left-0 w-full bg-white">
          <slot name="footer"></slot>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup lang="ts">
type Props = {
  open: boolean;
  logoSize?: "sm" | "base";
  transition?: "enter-from-left" | "enter-from-right" | "fade";
  backgroundBlur?: boolean;
  headerBorderBottom?: boolean;
  sticky?: boolean;
  scrollDisabled?: boolean;
};

const props = withDefaults(defineProps<Props>(), {
  headerBorderBottom: false,
  scrollDisabled: false,
  sticky: false,
  transition: "fade",
  logoSize: "base",
});

defineEmits<{
  close: [];
}>();

const dialogContainer = ref<HTMLElement | null>(null);
const { y } = useScroll(dialogContainer);

const showHeaderBorderBottom = computed(
  () => y.value > 0 && props.headerBorderBottom
);

useLockBackground(() => props.open);
</script>
